import React, { useEffect, useState } from 'react'
import {
  Grid,
  FormControl,
  FormControlLabel,
  FormGroup,
  Checkbox,
  Button,
  RadioGroup,
  Radio,
  Select,
  MenuItem,
  TextField,
  CircularProgress,
} from '@material-ui/core'
import './crearFormulario.scss'
import { useForm } from '../../../../context/formContext'
import { useAuthentication } from '../../../../context/authenticationContext'
import * as Yup from 'yup'
import { useFormik } from 'formik'
import { useHistory } from 'react-router-dom'
import swal from 'sweetalert'
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline'
import ReactTooltip from 'react-tooltip'
import { createForm } from '../../../../services/Forms/create'
import {
  activosFijosIdsQuestion,
  activosTotalesIdsQuestion,
  activitySectorIdsQuestion,
} from '../../data/dataActivityIds'
import { getPreIFIPDF } from '../../../../services/IFI/get'
import { insertAzureBlobStorageService } from '../../../../services/AsistenciaTecnica/create'
import Swal from 'sweetalert2'
import NumberFormat from 'react-number-format'

const EvaluationData = (props) => {
  const { previousStep } = props
  const history = useHistory()
  const { userCountry, userIDB2C } = useAuthentication()
  const {
    setStep,
    step,
    sectors,
    setPreEligibilityForm,
    preEligibilityForm,
    climateThreat,
    adaptationActions,
    lineOfBusiness,
    setSectorID,
    getSectorActivityForm,
    setActivitySector,
    activitySector,
    getQuestionActivity,
    setActivityID,
    activityID,
    sectorID,
    setQuetions,
    questionsData,
    questions,
    setQuetionsData,
  } = useForm()

  const [selectedSector, setSelectedSector] = useState('')
  const [showQuestion, setShowQuestion] = useState(false)
  const [loading, setLoading] = useState(false)
  const [showClass, setShowClass] = useState(false)
  const [selectedClass, setSelectedClass] = useState('')
  const [selectedActivitySector, setSelectedActivitySector] = useState(null)

  // Activity - InputDetail
  const [showActivityDetail, setShowActivityDetail] = useState(false)
  const [errorDetailActivity, setErrorDetailActivity] = useState(false)
  const [helperTextDetailActivity, setHelperTextDetailActivity] = useState('')

  // Sector - InputDetail
  const [showOtherSectors, setShowOtherSectors] = useState(false)
  const [errorDetailSector, setErrorDetailSector] = useState(false)
  const [helperTextDetailSector, setHelperTextDetailSector] = useState('')
  const [nameSector, setNameSector] = useState('')
  // Activity Sector - Select
  const [showActivitySector, setShowActivitySector] = useState(false)
  const [errorSelectActivitySector, setErrorSelectActivitySector] =
    useState(false)
  const [helperTextSelectActivitySector, setHelperTextSelectActivitySector] =
    useState('')

  // affectsCulturalHeritage - RadioButton
  const [
    errorRadioAffectsCulturalHeritageDetail,
    setErrorRadioAffectsCulturalHeritageDetail,
  ] = useState(false)
  const [
    helperTextAffectsCulturalHeritageDetail,
    setHelperTextAffectsCulturalHeritageDetail,
  ] = useState('')
  // affectsCulturalHeritage - InputDetail
  const [
    showAffectsCulturalHeritageDetail,
    setShowAffectsCulturalHeritageDetail,
  ] = useState(false)
  const [
    errorDetailAffectsCulturalHeritage,
    setErrorDetailAffectsCulturalHeritage,
  ] = useState(false)
  const [
    helperTextDetailAffectsCulturalHeritage,
    setHelperTextDetailAffectsCulturalHeritage,
  ] = useState('')

  // isInProtectedArea - RadioButton
  const [errorRadioisInProtectedArea, setErrorRadioisInProtectedArea] =
    useState(false)
  const [helperTextIsInProtectedArea, setHelperTextIsInProtectedArea] =
    useState('')
  // isInProtectedArea - InputDetail
  const [showIsInProtectedArea, setShowIsInProtectedArea] = useState(false)
  const [errorDetailisInProtectedArea, setErrorDetailisInProtectedArea] =
    useState(false)
  const [
    helperTextDetailIsInProtectedArea,
    setHelperTextDetailIsInProtectedArea,
  ] = useState('')

  // ClimateThreatDetail - Input
  const [showClimateThreatDetail, setShowClimateThreatDetail] = useState(false)
  const [errorDetailClimateThreat, setErrorDetailClimateThreat] =
    useState(false)
  const [helperTextDetailClimateThreat, setHelperTextDetailClimateThreat] =
    useState('')

  // AdaptationActionsDetail - Input
  const [showAdaptationActionsDetail, setShowAdaptationActionsDetail] =
    useState(false)
  const [errorDetailAdaptationActions, setErrorDetailAdaptationActions] =
    useState(false)
  const [
    helperTextDetailAdaptationActions,
    setHelperTextDetailAdaptationActions,
  ] = useState('')

  // negativeImpact
  const [errorCheckNegativeImpact, setErrorCheckNegativeImpact] =
    useState(false)
  const [helperTextNegativeImpact, setHelperTextNegativeImpact] = useState('')
  const [negativeImpact, setNegativeImpact] = useState([])

  // Declaration
  const [compilanceStatement, setCompilanceStatement] = useState({})
  const [errorCompilanceStatement, setErrorCompilanceStatement] =
    useState(false)
  const [helperTextCompilanceStatement, setHelperTextCompilanceStatement] =
    useState('')

  const [percentageTitle, setPercentageClass] = useState('')

  const [idQuestionClass, setIdQuestionClass] = useState('')

  const EvaluationDataSchema = Yup.object().shape({
    idSector: Yup.number().required('Este campo es obligatorio'),
    idSectorActivity: Yup.number(),
    detailSector: Yup.string(),
    detailActivity: Yup.string(),
    affectsCulturalHeritage: Yup.string(),
    detailAffectsCulturalHeritage: Yup.string(),
    isInProtectedArea: Yup.string(),
    protectedAreaLocation: Yup.string().matches(
      /[\\sa-zA-ZñÑ0-9/#()-]{0,150}/,
      'El campo contiene carácteres no validos',
    ),
    idClimateThreat: Yup.number().required('Este campo es obligatorio'),
    detailClimateThreat: Yup.string(),
    idAdaptationAction: Yup.number().required('Este campo es obligatorio'),
    detailAdaptationAction: Yup.string(),
    idBusinessLine: Yup.number().required('Este campo es obligatorio'),
    questionNumeric: Yup.string(),
    questionDecimal: Yup.string(),
    validateNumeric: Yup.boolean().oneOf([true], 'El monto debe mayor que 0'),
  })

  const alertValidationFields = () => {
    swal({
      title: 'Favor validar: si hay errores o campos pendientes por completar',
      icon: 'warning',
      button: 'Entendido',
      className: 'swal-title',
    })
  }

  const validateFormStatus = () => {
    if (!formik.isValid) {
      alertValidationFields()
    }
  }

  const getActualDate = () => {
    const hoy = new Date()
    const meses = [
      'Enero',
      'Febrero',
      'Marzo',
      'Abril',
      'Mayo',
      'Junio',
      'Julio',
      'Agosto',
      'Septiembre',
      'Octubre',
      'Noviembre',
      'Diciembre',
    ]

    const arrayData = []
    const fecha =
      hoy.getDate() + '-' + meses[hoy.getMonth()] + '-' + hoy.getFullYear()
    const minutos = (hoy.getMinutes() < 10 ? '0' : '') + hoy.getMinutes()
    let horas = hoy.getHours()
    const ampm = horas >= 12 ? 'PM' : 'AM'
    horas = horas % 12
    const date = fecha + ' ' + horas + ':' + minutos + ':' + ampm

    arrayData.push(date)
    arrayData.push(fecha)

    return arrayData
  }

  const downloadPreIFIPDF = async (
    idForm,
    codeForm,
    projectName,
    IdFormHistory,
    IdUser,
    mensaje,
    icon,
  ) => {
    if (idForm !== null) {
      const date = await getActualDate()
      await getPreIFIPDF(idForm, date[0]).then((response) => {
        if (response) {
          blobToBase64(response).then((res) => {
            insertAzureBlob(res, idForm, IdFormHistory, IdUser, mensaje, icon)
          })
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Ha ocurrido un error al intentar generar el pdf',
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'Reintentar',
            footer:
              '<a href="mailto: comunicacionesCAMBio@bcie.org">Contactar al administrador</a>',
            allowOutsideClick: false,
            allowEscapeKey: false,
          })
        }
      })
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Ha ocurrido un error al intentar generar el pdf',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Reintentar',
        footer:
          '<a href="mailto: comunicacionesCAMBio@bcie.org">Contactar al administrador</a>',
        allowOutsideClick: false,
        allowEscapeKey: false,
      })
    }
  }

  const blobToBase64 = (blob) => {
    const reader = new FileReader()
    reader.readAsDataURL(blob)
    return new Promise((resolve) => {
      reader.onloadend = () => {
        resolve(reader.result.toString().replace(/^data:(.*,)?/, ''))
      }
    })
  }

  const insertAzureBlob = async (
    documentpdf,
    idForm,
    IdFormHistory,
    IdUser,
    mensaje,
    icon,
  ) => {
    const document = {
      FileContents: documentpdf,
      FileExtension: 'pdf',
      FileName: 'Pre-Elegibilidad',
      Description: 'Pre-Elegibilidad',
      SizeMB: 0,
      IdForm: idForm,
      IdUser: userIDB2C,
      RelatedFormField: 76,
      IdFormHistory: IdFormHistory,
    }
    try {
      const response = await insertAzureBlobStorageService(document)
      if (response.Success) {
        setLoading(false)
        swal({
          title: `Registrado`,
          text: `${mensaje}`,
          icon: `${icon}`,
          closeOnClickOutside: false,
          closeOnEsc: false,
          buttons: {
            catch: {
              text: 'Entendido',
              value: 'catch',
            },
          },
        }).then((value) => {
          switch (value) {
            case 'catch':
              history.push('/')
              swal.close()
              break
            default:
              swal.close()
          }
        })
      }
    } catch (error) {
      console.error(error)
      setLoading(false)
    }
  }

  const formik = useFormik({
    initialValues: {
      idSector: '',
      idSectorActivity: '',
      detailSector: '',
      detailActivity: '',
      affectsCulturalHeritage: '',
      detailAffectsCulturalHeritage: '',
      isInProtectedArea: '',
      protectedAreaLocation: '',
      idClimateThreat: '',
      detailClimateThreat: '',
      idAdaptationAction: '',
      detailAdaptationAction: '',
      idBusinessLine: '',
      answerActivityQuestion: [],
      questionNumeric: '',
      questionDecimal: '',
      validateNumeric: true,
    },
    validationSchema: EvaluationDataSchema,
    onSubmit: (values) => {
      let activitySectorIsValid = false
      let affectsCulturalHeritageIsValid = false
      let isInProtectedAreaIsValid = false
      let negativeImpactIsValid = false
      let isInvalidsectorsActivitiesQuestions = false
      let detailSectorIsValid = false
      let detailActivityIsValid = false
      let detailClimateThreatIsValid = false
      let detailAdaptationActionsIsValid = false

      if (showQuestion && questions && questions.length > 0) {
        for (let i = 0; i < questions.length; i++) {
          if (questions[i].QuestionTypeName === 'Numeric') {
            const inputDivError = document.getElementById(
              `idNumericError-${questions[i].IdActivityQuestion}`,
            )
            if (inputDivError && inputDivError.innerHTML !== '') {
              isInvalidsectorsActivitiesQuestions = true
            }
          }

          if (questions[i].QuestionTypeName === 'String') {
            const inputDivError = document.getElementById(
              `idStringError-${questions[i].IdActivityQuestion}`,
            )
            if (inputDivError && inputDivError.innerHTML !== '') {
              isInvalidsectorsActivitiesQuestions = true
            }
          }

          if (questions[i].QuestionTypeName === 'Decimal') {
            const inputDivError = document.getElementById(
              `idDecimalError-${questions[i].IdActivityQuestion}`,
            )
            if (inputDivError && inputDivError.innerHTML !== '') {
              isInvalidsectorsActivitiesQuestions = true
            }
          }

          if (questions[i].QuestionTypeName === 'ListValues') {
            const inputDivError = document.getElementById(
              `idSelectError-${questions[i].IdActivityQuestion}`,
            )
            if (inputDivError && inputDivError.innerHTML !== '') {
              isInvalidsectorsActivitiesQuestions = true
            }
          }
        }
      }

      if (showOtherSectors) {
        if (values.detailSector === '') {
          detailSectorIsValid = false
          setHelperTextDetailSector('Este campo es requerido')
          setErrorDetailSector(true)
        } else {
          detailSectorIsValid = true
        }
        if (values.detailActivity === '') {
          detailActivityIsValid = false
          setHelperTextDetailActivity('Este campo es requerido')
          setErrorDetailActivity(true)
        } else {
          detailActivityIsValid = true
        }
      } else {
        detailSectorIsValid = true
        detailActivityIsValid = true
      }

      if (showActivityDetail) {
        if (values.detailActivity === '') {
          detailActivityIsValid = false
          setHelperTextDetailActivity('Este campo es requerido')
          setErrorDetailActivity(true)
        } else {
          detailActivityIsValid = true
        }
      }

      if (values.idSectorActivity === '') {
        setHelperTextSelectActivitySector('Este campo es obligatorio')
        setErrorSelectActivitySector(true)
      } else {
        if (showActivitySector && values.idSectorActivity === '') {
          setHelperTextSelectActivitySector('Este campo es obligatorio')
          setErrorSelectActivitySector(true)
        } else {
          activitySectorIsValid = true
        }
      }

      if (values.affectsCulturalHeritage === '') {
        setHelperTextAffectsCulturalHeritageDetail('Este campo es obligatorio')
        setErrorRadioAffectsCulturalHeritageDetail(true)
      } else {
        if (
          showAffectsCulturalHeritageDetail &&
          values.detailAffectsCulturalHeritage === ''
        ) {
          setHelperTextDetailAffectsCulturalHeritage(
            'Este campo es obligatorio',
          )
          setErrorDetailAffectsCulturalHeritage(true)
        } else {
          affectsCulturalHeritageIsValid = true
        }
      }

      if (values.isInProtectedArea === '') {
        setHelperTextIsInProtectedArea('Este campo es obligatorio')
        setErrorRadioisInProtectedArea(true)
      } else {
        if (showIsInProtectedArea && values.protectedAreaLocation === '') {
          setHelperTextDetailIsInProtectedArea('Este campo es obligatorio')
          setErrorDetailisInProtectedArea(true)
        } else {
          isInProtectedAreaIsValid = true
        }
      }

      if (showClimateThreatDetail) {
        if (values.detailClimateThreat === '') {
          detailClimateThreatIsValid = false
          setHelperTextDetailClimateThreat('Este campo es obligatorio')
          setErrorDetailClimateThreat(true)
        } else {
          detailClimateThreatIsValid = true
        }
      } else {
        detailClimateThreatIsValid = true
      }

      if (showAdaptationActionsDetail) {
        if (values.detailAdaptationAction === '') {
          detailAdaptationActionsIsValid = false
          setHelperTextDetailAdaptationActions('Este campo es obligatorio')
          setErrorDetailAdaptationActions(true)
        } else {
          detailAdaptationActionsIsValid = true
        }
      } else {
        detailAdaptationActionsIsValid = true
      }

      if (negativeImpact.length === 0) {
        setHelperTextNegativeImpact('Este campo es obligatorio')
        setErrorCheckNegativeImpact(true)
      } else {
        negativeImpactIsValid = true
      }
      if (!compilanceStatement.status) {
        setHelperTextCompilanceStatement('Este campo es obligatorio')
        setErrorCompilanceStatement(true)
      }

      if (
        !isInvalidsectorsActivitiesQuestions &&
        activitySectorIsValid &&
        detailSectorIsValid &&
        detailActivityIsValid &&
        detailClimateThreatIsValid &&
        detailAdaptationActionsIsValid &&
        affectsCulturalHeritageIsValid &&
        isInProtectedAreaIsValid &&
        negativeImpactIsValid &&
        compilanceStatement.status
      ) {
        save()
      } else {
        alertValidationFields()
      }
    },
  })

  const resultEmpleados = questions[0]?.QuestionName?.includes('Empleados')

  useEffect(() => {
    if (preEligibilityForm?.answerActivityQuestion !== []) {
      for (
        var i = 0;
        i < preEligibilityForm?.answerActivityQuestion?.length;
        i++
      ) {
        if (
          Number(preEligibilityForm.answerActivityQuestion[i].value) === 0 &&
          preEligibilityForm.answerActivityQuestion[i].ValueType ===
            'Numeric' &&
          preEligibilityForm.answerActivityQuestion[i].value !== ''
        ) {
          const inputDivError = document.getElementById(
            `validateAmount-${preEligibilityForm.answerActivityQuestion[i].idActivityQuestion}`,
          )

          if (inputDivError) {
            inputDivError.innerHTML = 'El valor debe ser mayor que 0'
          }
        }

        if (
          (Number(preEligibilityForm.answerActivityQuestion[i].value) > 0 &&
            preEligibilityForm.answerActivityQuestion[i].ValueType ===
              'Numeric') ||
          preEligibilityForm.answerActivityQuestion[i].value === ''
        ) {
          const inputDivError = document.getElementById(
            `validateAmount-${preEligibilityForm.answerActivityQuestion[i].idActivityQuestion}`,
          )
          if (inputDivError) {
            inputDivError.innerHTML = ''
          }
        }

        // valores decimales
        if (
          Number(preEligibilityForm.answerActivityQuestion[i].value) === 0 &&
          preEligibilityForm.answerActivityQuestion[i].ValueType ===
            'Decimal' &&
          preEligibilityForm.answerActivityQuestion[i].value !== ''
        ) {
          const inputDivError = document.getElementById(
            `idDecimalErrorValidate-${preEligibilityForm.answerActivityQuestion[i].idActivityQuestion}`,
          )

          if (inputDivError) {
            inputDivError.innerHTML = 'El valor debe ser mayor que 0'
          }
        }

        if (
          (Number(preEligibilityForm.answerActivityQuestion[i].value) > 0 &&
            preEligibilityForm.answerActivityQuestion[i].ValueType ===
              'Decimal') ||
          preEligibilityForm.answerActivityQuestion[i].value === ''
        ) {
          const inputDivError = document.getElementById(
            `idDecimalErrorValidate-${preEligibilityForm.answerActivityQuestion[i].idActivityQuestion}`,
          )
          if (inputDivError) {
            inputDivError.innerHTML = ''
          }
        }

        const result = preEligibilityForm?.answerActivityQuestion?.filter(
          (obj) =>
            Number(obj.value) === 0 &&
            (obj.ValueType === 'Numeric' || obj.ValueType === 'Decimal'),
        )
        if (result.length === 0) formik.setFieldValue('validateNumeric', true)
        else {
          formik.setFieldValue('validateNumeric', false)
        }
      }
    }
  }, [preEligibilityForm?.answerActivityQuestion, questions, questionsData])

  useEffect(() => {
    if (resultEmpleados) {
      // setQuetionsData([
      //   ...questionsData,
      //   {
      //     idActivityQuestion: questions[0]?.IdActivityQuestion,
      //     value: preEligibilityForm.quantityEmployees,
      //     ValueType: questions[0]?.QuestionTypeName,
      //   },
      // ])

      // setPreEligibilityForm({
      //   ...preEligibilityForm,
      //   answerActivityQuestion: questionsData,
      // })
      setPreEligibilityForm({
        ...preEligibilityForm,
        answerActivityQuestion: [
          {
            idActivityQuestion: questions[0]?.IdActivityQuestion,
            value: preEligibilityForm.quantityEmployees.toString(),
            ValueType: questions[0]?.QuestionTypeName,
          },
        ],
      })
    }
  }, [resultEmpleados])

  const save = () => {
    setLoading(true)

    let payload
    const res = 'answerActivityQuestion' in preEligibilityForm
    if (res) {
      payload = {
        ...preEligibilityForm,
        draft: false,
        detailBusinessLine: '',
        answerActivityQuestion: preEligibilityForm.answerActivityQuestion,
      }
    } else {
      payload = {
        ...preEligibilityForm,
        draft: false,
        answerActivityQuestion: preEligibilityForm.answerActivityQuestion,
        detailBusinessLine: '',
      }
    }
    createForm(payload)
      .then((res) => {
        if (res.Code === 200) {
          const mensaje = `${res.Data.Mensaje} \n Estado de Formulario: ${
            res.Data.FormStatus
          } \n ${userCountry === '1' ? `P: ${res.Data.Score}` : ''}`
          const icon =
            res.Data.FormStatus === 'No Pre-Elegible' ? 'error' : 'success'

          downloadPreIFIPDF(
            res.Data.IdForm,
            undefined,
            'Pre-elegibilidad',
            res.Data.IdFormHistory,
            res.Data.IdUser,
            mensaje,
            icon,
          )

          // if (res.Data.FormStatus === 'En revisión') {
          //   downloadPreIFIPDF(
          //     res.Data.IdForm,
          //     undefined,
          //     'Pre-elegibilidad',
          //     res.Data.IdFormHistory,
          //     res.Data.IdUser,
          //     mensaje,
          //   )
          // } else {
          //   setLoading(false)
          //   swal({
          //     title: `Registrado`,
          //     text: `${mensaje}`,
          //     icon: `${icon}`,
          //     closeOnClickOutside: false,
          //     closeOnEsc: false,
          //     buttons: {
          //       catch: {
          //         text: 'Continuar',
          //         value: 'catch',
          //       },
          //     },
          //   }).then((value) => {
          //     switch (value) {
          //       case 'catch':
          //         history.push('/')
          //         swal.close()
          //         break
          //       default:
          //         swal.close()
          //     }
          //   })
          // }
        }
      })
      .catch((err) => {
        console.log(err)
        setLoading(false)
      })
  }

  const handleChangeAffectsCulturalHeritage = (e) => {
    formik.setFieldValue('affectsCulturalHeritage', e.target.value)
    setErrorRadioAffectsCulturalHeritageDetail(false)
    setHelperTextAffectsCulturalHeritageDetail('')
    if (e.target.value === 'si') {
      setShowAffectsCulturalHeritageDetail(true)
      setPreEligibilityForm({
        ...preEligibilityForm,
        affectsCulturalHeritage: true,
      })
    } else {
      setShowAffectsCulturalHeritageDetail(false)
      formik.setFieldValue('detailAffectsCulturalHeritage', '')
      setPreEligibilityForm({
        ...preEligibilityForm,
        affectsCulturalHeritage: false,
        detailAffectsCulturalHeritage: '',
      })
    }
  }

  const handleChangeIsInProtectedArea = (e) => {
    formik.setFieldValue('isInProtectedArea', e.target.value)
    setErrorRadioisInProtectedArea(false)
    setHelperTextIsInProtectedArea('')
    if (e.target.value === 'si') {
      setShowIsInProtectedArea(true)
      setPreEligibilityForm({ ...preEligibilityForm, isInProtectedArea: true })
    } else {
      setShowIsInProtectedArea(false)
      formik.setFieldValue('protectedAreaLocation', '')
      setPreEligibilityForm({
        ...preEligibilityForm,
        isInProtectedArea: false,
        protectedAreaLocation: '',
      })
    }
  }

  const handleChangeNegativeImpact = (e) => {
    setHelperTextNegativeImpact('')
    const data = negativeImpact
    if (data.includes(e.target.value)) {
      const index = data.findIndex((item) => item === e.target.value)
      data.splice(index, 1)
    } else {
      data.push(e.target.value)
    }
    setNegativeImpact(data)
    setPreEligibilityForm({
      ...preEligibilityForm,
      negativeImpact: data.length === 0 ? '' : data,
    })
  }

  const handleChangeDeclaration = (event) => {
    setHelperTextCompilanceStatement('')
    setCompilanceStatement({
      ...compilanceStatement,
      [event.target.name]: event.target.checked,
    })
  }

  const previous = () => {
    setStep(step - 1)
    previousStep()
  }

  useEffect(() => {
    if (!showClimateThreatDetail) {
      setErrorDetailClimateThreat(false)
      setHelperTextDetailClimateThreat('')
      formik.setFieldValue('detailClimateThreat', '')
    }
  }, [showClimateThreatDetail])

  useEffect(() => {
    if (!showAdaptationActionsDetail) {
      setErrorDetailAdaptationActions(false)
      setHelperTextDetailAdaptationActions('')
      formik.setFieldValue('detailAdaptationAction', '')
    }
  }, [showAdaptationActionsDetail])

  useEffect(() => {
    if (
      selectedSector !== '' &&
      selectedSector !== null &&
      selectedSector !== 0
    ) {
      if (selectedSector === 8) {
        setShowActivityDetail(false)
        setShowActivitySector(false)
        setShowOtherSectors(true)
        formik.setFieldValue('idSectorActivity', 0)
        setPreEligibilityForm({
          ...preEligibilityForm,
          answerActivityQuestion: [],
        })
      } else {
        if (typeof selectedSector === 'number') {
          setSectorID(selectedSector)
        }
        getSectorActivityForm()
        for (let i = 0; i < sectors.length; i++) {
          if (sectors[i].idSector === selectedSector) {
            setSelectedSector(sectors[i].description)
          }
        }
        formik.setFieldValue('detailSector', '')
        formik.setFieldValue('detailActivity', '')
        formik.setFieldValue('idSectorActivity', '')
        setShowActivitySector(true)
        setShowOtherSectors(false)
        setShowActivityDetail(false)
        setErrorDetailSector(false)
        setHelperTextDetailSector('')
        setErrorDetailActivity(false)
        setHelperTextDetailActivity('')
      }
    } else {
      setShowActivitySector(false)
      setShowOtherSectors(false)
      setShowActivityDetail(false)
      setActivitySector([])
      setShowQuestion(false)
      setQuetions([])
      setShowClass(false)
      setSelectedClass('')
      setActivitySector(null)
      formik.setFieldValue('detailSector', '')
      formik.setFieldValue('detailActivity', '')
      formik.setFieldValue('idSectorActivity', '')
      setErrorDetailSector(false)
      setHelperTextDetailSector('')
      setErrorDetailActivity(false)
      setHelperTextDetailActivity('')
    }
  }, [selectedSector, sectors])

  useEffect(() => {
    if (formik.values.idSectorActivity === 230) {
      setShowOtherSectors(false)
      setShowActivitySector(true)
      setShowActivityDetail(true)
      setPreEligibilityForm({
        ...preEligibilityForm,
        answerActivityQuestion: [],
      })
    } else {
      setShowActivityDetail(false)
      formik.setFieldValue('detailActivity', '')
      setErrorDetailActivity(false)
      setHelperTextDetailActivity('')
    }
  }, [formik.values.idSectorActivity])

  useEffect(() => {
    if (
      formik.values.idSector !== '' &&
      formik.values.idSectorActivity !== ''
    ) {
      setPreEligibilityForm({
        ...preEligibilityForm,
        answerActivityQuestion: [],
      })
      getQuestionActivity()
      setShowQuestion(true)
    } else {
      setShowQuestion(false)
    }
  }, [sectorID, activityID])

  let contador = 0

  const handleQuestions = (id, value, type) => {
    // const questionIndex = questionsData.findIndex(
    //   (item) => item.IdActivityQuestion === id,
    // )

    // if (questionIndex >= 0) {
    //   questionsData[questionIndex].value = value
    // } else {
    //   questionsData.push({
    //     idActivityQuestion: id,
    //     value: value,
    //     ValueType: type,
    //   })
    // }

    // setPreEligibilityForm({
    //   ...preEligibilityForm,
    //   answerActivityQuestion: questionsData,
    // })
    let newObjet = questionsData
    const result = questionsData.filter((obj) => obj.idActivityQuestion === id)

    if (result.length > 0) {
      const newState = questionsData.map((obj) => {
        if (obj.idActivityQuestion === id) {
          obj.value = value
        }

        return obj
      })

      setQuetionsData(newState)
      newObjet = newState
    } else {
      newObjet = [
        ...newObjet,
        {
          IdActivityQuestion: id,
          Value: value,
          ValueType: type,
        },
      ]
      setQuetionsData([
        ...questionsData,
        {
          idActivityQuestion: id,
          value: value,
          ValueType: type,
        },
      ])
    }

    setPreEligibilityForm({
      ...preEligibilityForm,
      answerActivityQuestion: newObjet,
    })
  }

  useEffect(() => {
    if (activityID) {
      setPreEligibilityForm({
        ...preEligibilityForm,
        answerActivityQuestion: [],
      })
      if (showQuestion && userCountry === '1') {
        setSelectedActivitySector(null)
        validateActivitySector()
        setPlaceholderActivitySector()
      }
      if (questions && questions.length > 0) {
        for (let i = 0; i < questions.length; i++) {
          if (questions[i].QuestionTypeName === 'ListValues') {
            const inputDiv = document.getElementById(
              `idSelect-${questions[i].IdActivityQuestion}`,
            )
            const inputSelect = document.getElementById(
              `idInputSelect-${questions[i].IdActivityQuestion}`,
            )
            if (inputDiv) {
              document.getElementById(
                `idSelect-${questions[i].IdActivityQuestion}`,
              ).innerHTML = ''
            }
            if (inputSelect) {
              document.getElementById(
                `idInputSelect-${questions[i].IdActivityQuestion}`,
              ).value = ''
            }
          }

          if (questions[i].QuestionTypeName === 'Numeric') {
            const input = document.getElementById(
              `idNumeric-${questions[i].IdActivityQuestion}`,
            )
            if (input) {
              input.value = ''
            }
            const inputError = document.getElementById(
              `idNumericError-${questions[i].IdActivityQuestion}`,
            )
            if (inputError) {
              inputError.innerHTML = ''
            }
          }

          if (questions[i].QuestionTypeName === 'String') {
            const input = document.getElementById(
              `idString-${questions[i].IdActivityQuestion}`,
            )
            if (input) {
              input.value = ''
            }
            const inputError = document.getElementById(
              `idStringError-${questions[i].IdActivityQuestion}`,
            )
            if (inputError) {
              inputError.innerHTML = ''
            }
          }

          if (questions[i].QuestionTypeName === 'Decimal') {
            const input = document.getElementById(
              `idDecimal-${questions[i].IdActivityQuestion}`,
            )
            if (input) {
              input.value = ''
            }
            const inputError = document.getElementById(
              `idDecimalError-${questions[i].IdActivityQuestion}`,
            )
            if (inputError) {
              inputError.innerHTML = ''
            }
          }
        }
      }
      setQuetionsData([])
    }
  }, [activityID])

  useEffect(() => {
    if (selectedActivitySector) {
      if (showQuestion && userCountry === '1') {
        for (let i = 0; i < questions.length; i++) {
          if (questions[i].QuestionTypeName === 'ListValues') {
            handleQuestions(
              questions[i].IdActivityQuestion,
              selectedActivitySector,
              questions[i].QuestionTypeName,
            )
          }
        }
        validateActivitySector()
        setPlaceholderActivitySector()
      }
      if (questions && questions.length > 0) {
        for (let i = 0; i < questions.length; i++) {
          if (questions[i].QuestionTypeName === 'Numeric') {
            const input = document.getElementById(
              `idNumeric-${questions[i].IdActivityQuestion}`,
            )
            if (input) {
              input.value = ''
            }
            const inputError = document.getElementById(
              `idNumericError-${questions[i].IdActivityQuestion}`,
            )
            if (inputError) {
              inputError.innerHTML = ''
            }
          }

          if (questions[i].QuestionTypeName === 'String') {
            const input = document.getElementById(
              `idString-${questions[i].IdActivityQuestion}`,
            )
            if (input) {
              input.value = ''
            }
            const inputError = document.getElementById(
              `idStringError-${questions[i].IdActivityQuestion}`,
            )
            if (inputError) {
              inputError.innerHTML = ''
            }
          }

          if (questions[i].QuestionTypeName === 'Decimal') {
            const input = document.getElementById(
              `idDecimal-${questions[i].IdActivityQuestion}`,
            )
            if (input) {
              input.value = ''
            }
            const inputError = document.getElementById(
              `idDecimalError-${questions[i].IdActivityQuestion}`,
            )
            if (inputError) {
              inputError.innerHTML = ''
            }
          }
        }
      }
    }
  }, [selectedActivitySector])

  useEffect(() => {
    if (showQuestion && questions && questions.length > 0) {
      if ('answerActivityQuestion' in preEligibilityForm) {
        if (
          questions.length !== preEligibilityForm.answerActivityQuestion.length
        ) {
          for (let i = 0; i < questions.length; i++) {
            if (questions[i].QuestionTypeName === 'Numeric') {
              const input = document.getElementById(
                `idNumeric-${questions[i].IdActivityQuestion}`,
              )
              if (input && input.getAttribute('disabled') === null) {
                if (input.value === '') {
                  const inputDivError = document.getElementById(
                    `idNumericError-${questions[i].IdActivityQuestion}`,
                  )
                  if (inputDivError) {
                    inputDivError.innerHTML = 'Este campo es requerido'
                  }
                } else {
                  const inputDivError = document.getElementById(
                    `idNumericError-${questions[i].IdActivityQuestion}`,
                  )
                  if (inputDivError) {
                    inputDivError.innerHTML = ''
                  }
                }
              } else {
                const inputDivError = document.getElementById(
                  `idNumericError-${questions[i].IdActivityQuestion}`,
                )
                if (inputDivError) {
                  inputDivError.innerHTML = ''
                }
              }
            }

            if (questions[i].QuestionTypeName === 'String') {
              const input = document.getElementById(
                `idString-${questions[i].IdActivityQuestion}`,
              )
              if (input && input.getAttribute('disabled') === null) {
                if (input.value === '') {
                  const inputDivError = document.getElementById(
                    `idStringError-${questions[i].IdActivityQuestion}`,
                  )
                  if (inputDivError) {
                    inputDivError.innerHTML = 'Este campo es requerido'
                  }
                } else {
                  const inputDivError = document.getElementById(
                    `idStringError-${questions[i].IdActivityQuestion}`,
                  )
                  if (inputDivError) {
                    inputDivError.innerHTML = ''
                  }
                }
              } else {
                const inputDivError = document.getElementById(
                  `idStringError-${questions[i].IdActivityQuestion}`,
                )
                if (inputDivError) {
                  inputDivError.innerHTML = ''
                }
              }
            }

            if (questions[i].QuestionTypeName === 'Decimal') {
              const input = document.getElementById(
                `idDecimal-${questions[i].IdActivityQuestion}`,
              )
              if (input && input.getAttribute('disabled') === null) {
                if (input.value === '') {
                  const inputDivError = document.getElementById(
                    `idDecimalError-${questions[i].IdActivityQuestion}`,
                  )
                  if (inputDivError) {
                    inputDivError.innerHTML = 'Este campo es requerido'
                  }
                } else {
                  const inputDivError = document.getElementById(
                    `idDecimalError-${questions[i].IdActivityQuestion}`,
                  )
                  if (inputDivError) {
                    inputDivError.innerHTML = ''
                  }
                }
              } else {
                const inputDivError = document.getElementById(
                  `idDecimalError-${questions[i].IdActivityQuestion}`,
                )
                if (inputDivError) {
                  inputDivError.innerHTML = ''
                }
              }
            }

            if (questions[i].QuestionTypeName === 'ListValues') {
              const inputDiv = document.getElementById(
                `idSelect-${questions[i].IdActivityQuestion}`,
              )
              const inputSelect = document.getElementById(
                `idInputSelect-${questions[i].IdActivityQuestion}`,
              )
              if (inputDiv && inputDiv.getAttribute('disabled') === null) {
                if (inputSelect.value === '') {
                  const inputDivError = document.getElementById(
                    `idSelectError-${questions[i].IdActivityQuestion}`,
                  )
                  if (inputDivError) {
                    inputDivError.innerHTML = 'Este campo es requerido'
                  }
                } else {
                  const inputDivError = document.getElementById(
                    `idSelectError-${questions[i].IdActivityQuestion}`,
                  )
                  if (inputDivError) {
                    inputDivError.innerHTML = ''
                  }
                }
              } else {
                const inputDivError = document.getElementById(
                  `idSelectError-${questions[i].IdActivityQuestion}`,
                )
                if (inputDivError) {
                  inputDivError.innerHTML = ''
                }
              }
            }
          }
        } else {
          for (let i = 0; i < questions.length; i++) {
            if (questions[i].QuestionTypeName === 'Numeric') {
              const input = document.getElementById(
                `idNumeric-${questions[i].IdActivityQuestion}`,
              )
              if (input && input.getAttribute('disabled') === null) {
                if (input.value === '') {
                  const inputDivError = document.getElementById(
                    `idNumericError-${questions[i].IdActivityQuestion}`,
                  )
                  if (inputDivError) {
                    inputDivError.innerHTML = 'Este campo es requerido'
                  }
                } else {
                  const inputDivError = document.getElementById(
                    `idNumericError-${questions[i].IdActivityQuestion}`,
                  )
                  if (inputDivError) {
                    inputDivError.innerHTML = ''
                  }
                }
              } else {
                const inputDivError = document.getElementById(
                  `idNumericError-${questions[i].IdActivityQuestion}`,
                )
                if (inputDivError) {
                  inputDivError.innerHTML = ''
                }
              }
            }

            if (questions[i].QuestionTypeName === 'String') {
              const input = document.getElementById(
                `idString-${questions[i].IdActivityQuestion}`,
              )
              if (input && input.getAttribute('disabled') === null) {
                if (input.value === '') {
                  const inputDivError = document.getElementById(
                    `idStringError-${questions[i].IdActivityQuestion}`,
                  )
                  if (inputDivError) {
                    inputDivError.innerHTML = 'Este campo es requerido'
                  }
                } else {
                  const inputDivError = document.getElementById(
                    `idStringError-${questions[i].IdActivityQuestion}`,
                  )
                  if (inputDivError) {
                    inputDivError.innerHTML = ''
                  }
                }
              } else {
                const inputDivError = document.getElementById(
                  `idStringError-${questions[i].IdActivityQuestion}`,
                )
                if (inputDivError) {
                  inputDivError.innerHTML = ''
                }
              }
            }

            if (questions[i].QuestionTypeName === 'Decimal') {
              const input = document.getElementById(
                `idDecimal-${questions[i].IdActivityQuestion}`,
              )
              if (input && input.getAttribute('disabled') === null) {
                if (input.value === '') {
                  const inputDivError = document.getElementById(
                    `idDecimalError-${questions[i].IdActivityQuestion}`,
                  )
                  if (inputDivError) {
                    inputDivError.innerHTML = 'Este campo es requerido'
                  }
                } else {
                  const inputDivError = document.getElementById(
                    `idDecimalError-${questions[i].IdActivityQuestion}`,
                  )
                  if (inputDivError) {
                    inputDivError.innerHTML = ''
                  }
                }
              } else {
                const inputDivError = document.getElementById(
                  `idDecimalError-${questions[i].IdActivityQuestion}`,
                )
                if (inputDivError) {
                  inputDivError.innerHTML = ''
                }
              }
            }

            if (questions[i].QuestionTypeName === 'ListValues') {
              const inputDiv = document.getElementById(
                `idSelect-${questions[i].IdActivityQuestion}`,
              )
              const inputSelect = document.getElementById(
                `idInputSelect-${questions[i].IdActivityQuestion}`,
              )
              if (inputDiv && inputDiv.getAttribute('disabled') === null) {
                if (inputSelect.value === '') {
                  const inputDivError = document.getElementById(
                    `idSelectError-${questions[i].IdActivityQuestion}`,
                  )
                  if (inputDivError) {
                    inputDivError.innerHTML = 'Este campo es requerido'
                  }
                } else {
                  const inputDivError = document.getElementById(
                    `idSelectError-${questions[i].IdActivityQuestion}`,
                  )
                  if (inputDivError) {
                    inputDivError.innerHTML = ''
                  }
                }
              } else {
                const inputDivError = document.getElementById(
                  `idSelectError-${questions[i].IdActivityQuestion}`,
                )
                if (inputDivError) {
                  inputDivError.innerHTML = ''
                }
              }
            }
          }
        }
      }
    }
  }, [showQuestion, questions, preEligibilityForm])

  useEffect(() => {
    if (activityID === 27 && userCountry === '5') {
      setShowClass(true)
    } else {
      setShowClass(false)
      setSelectedClass('')
    }
  }, [activityID])

  const validateActivitySector = (idQuestion) => {
    if (userCountry === '1' && selectedActivitySector) {
      if (
        activosTotalesIdsQuestion.includes(idQuestion) &&
        selectedActivitySector === 'Industrial'
      ) {
        return true
      }

      if (
        activosFijosIdsQuestion.includes(idQuestion) &&
        selectedActivitySector === 'Comercio y Servicios'
      ) {
        return true
      }
    } else if (userCountry === '1' && questions && questions.length > 0) {
      for (let i = 0; i < questions.length; i++) {
        if (
          (activitySectorIdsQuestion.includes(
            questions[i].IdActivityQuestion,
          ) &&
            !selectedActivitySector) ||
          (activitySectorIdsQuestion.includes(
            questions[i].IdActivityQuestion,
          ) &&
            selectedActivitySector === '')
        ) {
          return true
        }
      }
    }
  }

  const setPlaceholderActivitySector = (idQuestion) => {
    if (userCountry === '1' && selectedActivitySector) {
      if (
        activosTotalesIdsQuestion.includes(idQuestion) &&
        selectedActivitySector === 'Industrial'
      ) {
        return 'Campo no aplica para sector seleccionado'
      }

      if (
        activosFijosIdsQuestion.includes(idQuestion) &&
        selectedActivitySector === 'Comercio y Servicios'
      ) {
        return 'Campo no aplica para sector seleccionado'
      }
    } else if (userCountry === '1' && questions && questions.length > 0) {
      for (let i = 0; i < questions.length; i++) {
        if (
          (activitySectorIdsQuestion.includes(
            questions[i].IdActivityQuestion,
          ) &&
            !selectedActivitySector) ||
          (activitySectorIdsQuestion.includes(
            questions[i].IdActivityQuestion,
          ) &&
            selectedActivitySector === '')
        ) {
          return 'Debe seleccionar el Sector de la Actividad'
        }
      }
    }
  }

  const checkInputNumeric = (
    value,
    ref,
    idActivityQuestion,
    questionTypeName,
  ) => {
    const reference = document.getElementById(ref)
    if (reference.checkValidity()) {
      formik.setFieldValue('questionNumeric', value)
      handleQuestions(idActivityQuestion, value, questionTypeName)
    } else {
      if (preEligibilityForm.answerActivityQuestion.length > 0) {
        for (
          let i = 0;
          i < preEligibilityForm.answerActivityQuestion.length;
          i++
        ) {
          if (
            preEligibilityForm.answerActivityQuestion[i].IdActivityQuestion ===
            idActivityQuestion
          ) {
            reference.value = preEligibilityForm.answerActivityQuestion[i].value
            break
          } else {
            reference.value = ''
          }
        }
      } else {
        reference.value = ''
      }
    }
  }

  const checkInputDecimal = (
    value,
    ref,
    idActivityQuestion,
    questionTypeName,
  ) => {
    const reference = document.getElementById(ref)
    if (reference.checkValidity()) {
      formik.setFieldValue('questionDecimal', value)
      handleQuestions(idActivityQuestion, value, questionTypeName)
    } else {
      if (preEligibilityForm.answerActivityQuestion.length > 0) {
        for (
          let i = 0;
          i < preEligibilityForm.answerActivityQuestion.length;
          i++
        ) {
          if (
            preEligibilityForm.answerActivityQuestion[i].IdActivityQuestion ===
            idActivityQuestion
          ) {
            reference.value = preEligibilityForm.answerActivityQuestion[i].value
            break
          } else {
            reference.value = ''
          }
        }
      } else {
        reference.value = ''
      }
    }
  }

  const validateAll = (idActivityQuestion, questionName) => {
    if (
      userCountry === '5' &&
      questionName === 'Porcentaje de pendiente del terreno' &&
      selectedClass === ''
    ) {
      return true
    }

    if (
      userCountry === '5' &&
      questionName === 'Porcentaje de pendiente del terreno' &&
      selectedClass !== ''
    ) {
      return false
    }

    if (
      userCountry === '5' &&
      questionName !== 'Porcentaje de pendiente del terreno'
    ) {
      return false
    }

    /*  if (userCountry !== '5') {
      return validateActivitySector()
    } */
  }

  const validatePlaceHolder = (idActivityQuestion, questionName) => {
    const question = questionName.toLowerCase()

    if (
      userCountry === '5' &&
      question === 'porcentaje de pendiente del terreno' &&
      selectedClass === ''
    ) {
      return 'Seleccione una clase'
    }

    if (
      userCountry === '5' &&
      question === 'porcentaje de pendiente del terreno'
    ) {
      return ''
    }

    /* if (userCountry !== '5') {
      return setPlaceholderActivitySector(idActivityQuestion)
    } */
  }

  const handleClass = (value) => {
    const element = document.getElementById(idQuestionClass)
    let valueElement = ''

    const idActivityQuestion =
      idQuestionClass && idQuestionClass !== ''
        ? idQuestionClass.split('-')[1]
        : 212

    if (element && element.value !== '') {
      element.value = ''
      valueElement = element.value
    }

    handleQuestions(
      parseInt(idActivityQuestion),
      `${value}|${valueElement}`,
      'Subcategory',
    )

    setSelectedClass(value)
    switch (value) {
      case 1:
        return setPercentageClass('(0% - 2%)')
      case 2:
        return setPercentageClass('(2% - 4%)')
      case 3:
        return setPercentageClass('(4% - 12%)')
      case 4:
        return setPercentageClass('(12% - 25%)')
    }
  }

  const checkInputCategory = (
    value,
    reference,
    idActivityQuestion,
    questionTypeName,
  ) => {
    const idReference = document.getElementById(reference)
    setIdQuestionClass(reference)
    if (idReference.checkValidity()) {
      formik.setFieldValue('questionSubcategory', value)
      handleQuestions(
        idActivityQuestion,
        `${selectedClass}|${value}`,
        questionTypeName,
      )
    } else {
      if (preEligibilityForm.answerActivityQuestion.length > 0) {
        for (
          let i = 0;
          i < preEligibilityForm.answerActivityQuestion.length;
          i++
        ) {
          if (
            preEligibilityForm.answerActivityQuestion[i].IdActivityQuestion ===
            idActivityQuestion
          ) {
            let split = preEligibilityForm.answerActivityQuestion[i].value
            split = split.split('|')
            idReference.value = split[1]
            break
          } else {
            idReference.value = ''
          }
        }
      } else {
        idReference.value = ''
      }
    }
  }

  return (
    <>
      <form id="evaluation-data-form" onSubmit={formik.handleSubmit}>
        <Grid container spacing={1}>
          <Grid container spacing={1} className="input__container">
            <Grid item xs={12} sm={12} md={12}>
              <label className="responsiveLabel">
                14. Sector productivo <span style={{ color: 'red' }}>*</span>
                <a
                  data-tip="Seleccione el sector productivo de la MIPYME.<br/> Si este no está en el listado desplegable seleccionar<br/>“Otros sectores de producción sostenible” y detallarlo<br/>en el espacio correspondiente."
                  data-for="infoSector"
                  style={{ cursor: 'pointer' }}
                >
                  <ErrorOutlineIcon fontSize="small" />
                  <ReactTooltip
                    id="infoSector"
                    effect="solid"
                    multiline={true}
                    type="dark"
                  />
                </a>
              </label>
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <FormControl fullWidth>
                <Select
                  id="idSector"
                  value={formik.values.idSector}
                  onChange={(e) => {
                    if (sectorID !== 8) {
                      formik.setFieldValue('detailSector', '')
                      formik.setFieldValue('detailActivity', '')
                      formik.setFieldValue('idSectorActivity', 0)
                    }
                    formik.setFieldValue('idSector', e.target.value)
                    setSectorID(e.target.value)
                    setSelectedSector(e.target.value)
                    setPreEligibilityForm({
                      ...preEligibilityForm,
                      idSector: e.target.value,
                      idSectorActivity: 0,
                      detailActivity: '',
                      detailSector: '',
                    })
                  }}
                  variant="outlined"
                  error={formik.errors.idSector}
                >
                  <MenuItem value={''}>Seleccione una opción</MenuItem>
                  {sectors &&
                    sectors.map((item, key) => (
                      <MenuItem
                        key={key}
                        value={item.IdSector}
                        className="overFlowText"
                        onClick={(e) => {
                          setNameSector(e.target.innerText)
                        }}
                      >
                        {item.Description}
                      </MenuItem>
                    ))}
                </Select>
                {formik.errors.idSector ? (
                  <div
                    style={{ color: 'red', marginTop: '3px', fontSize: '13px' }}
                  >
                    {formik.errors.idSector}
                  </div>
                ) : null}
              </FormControl>
            </Grid>
          </Grid>

          {showActivitySector && (
            <Grid container spacing={1} className="input__container">
              <Grid item xs={12} sm={12} md={12}>
                <label className="responsiveLabel">
                  15. Actividades para{' '}
                  {/* {selectedSector && selectedSector.toString().toLowerCase()} */}
                  {nameSector.toString().toLowerCase()}
                </label>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <FormControl fullWidth>
                  <Select
                    id="idSectorActivity"
                    value={formik.values.idSectorActivity}
                    onChange={(e) => {
                      if (activityID !== 230) {
                        formik.setFieldValue('detailActivity', '')
                      }
                      if (e.target.value !== '') {
                        setErrorSelectActivitySector(false)
                        setHelperTextSelectActivitySector('')
                      }
                      formik.setFieldValue('idSectorActivity', e.target.value)
                      setActivityID(e.target.value)
                      setPreEligibilityForm({
                        ...preEligibilityForm,
                        idSectorActivity: e.target.value,
                        detailActivity: '',
                      })
                    }}
                    variant="outlined"
                    error={errorSelectActivitySector}
                  >
                    <MenuItem value={''}>Seleccione una opción</MenuItem>
                    {activitySector &&
                      activitySector.map((item, key) => (
                        <MenuItem
                          key={key}
                          value={item.IdActivity}
                          className="overFlowText"
                        >
                          {item.Description}
                        </MenuItem>
                      ))}
                  </Select>
                  {errorSelectActivitySector ? (
                    <div
                      style={{
                        color: 'red',
                        marginTop: '3px',
                        fontSize: '13px',
                      }}
                    >
                      {helperTextSelectActivitySector}
                    </div>
                  ) : null}
                </FormControl>
              </Grid>
            </Grid>
          )}

          {showOtherSectors && (
            <>
              <Grid container spacing={1} className="input__container">
                <Grid item xs={12} sm={12} md={12}>
                  <label className="responsiveLabel">
                    15. Detallar el sector productivo
                  </label>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <FormControl fullWidth>
                    <TextField
                      id="detailSector"
                      style={{ width: '100%' }}
                      variant="outlined"
                      value={formik.values.detailSector}
                      inputProps={{ autoComplete: 'off', maxLength: 95 }}
                      error={errorDetailSector}
                      onChange={(e) => {
                        formik.setFieldValue('detailSector', e.target.value)
                        setPreEligibilityForm({
                          ...preEligibilityForm,
                          detailSector: e.target.value,
                        })
                        setHelperTextDetailSector('')
                        setErrorDetailSector(false)
                      }}
                    />
                    {errorDetailSector ? (
                      <div
                        style={{
                          color: 'red',
                          marginTop: '3px',
                          fontSize: '13px',
                        }}
                      >
                        {helperTextDetailSector}
                      </div>
                    ) : null}
                  </FormControl>
                </Grid>
              </Grid>
              <Grid container spacing={1} className="input__container">
                <Grid item xs={12} sm={12} md={12}>
                  <label className="responsiveLabel">
                    15.1. Detallar la actividad a financiar
                  </label>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <FormControl fullWidth>
                    <TextField
                      id="detailActivity"
                      style={{ width: '100%' }}
                      variant="outlined"
                      value={formik.values.detailActivity}
                      inputProps={{ autoComplete: 'off', maxLength: 95 }}
                      error={errorDetailActivity}
                      onChange={(e) => {
                        formik.setFieldValue('detailActivity', e.target.value)
                        setPreEligibilityForm({
                          ...preEligibilityForm,
                          detailActivity: e.target.value,
                        })
                        setHelperTextDetailActivity('')
                        setErrorDetailActivity(false)
                      }}
                    />
                    {errorDetailActivity ? (
                      <div
                        style={{
                          color: 'red',
                          marginTop: '3px',
                          fontSize: '13px',
                        }}
                      >
                        {helperTextDetailActivity}
                      </div>
                    ) : null}
                  </FormControl>
                </Grid>
              </Grid>
            </>
          )}

          {showActivityDetail && (
            <Grid container spacing={1} className="input__container">
              <Grid item xs={12} sm={12} md={12}>
                <label className="responsiveLabel">
                  15.1. Detallar la actividad a financiar
                </label>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <FormControl fullWidth>
                  <TextField
                    id="detailActivity"
                    style={{ width: '100%' }}
                    variant="outlined"
                    inputProps={{ autoComplete: 'off', maxLength: 95 }}
                    error={errorDetailActivity}
                    value={formik.values.detailActivity}
                    onChange={(e) => {
                      formik.setFieldValue('detailActivity', e.target.value)
                      setPreEligibilityForm({
                        ...preEligibilityForm,
                        detailActivity: e.target.value,
                      })
                      setHelperTextDetailActivity('')
                      setErrorDetailActivity(false)
                    }}
                  />
                  {errorDetailActivity ? (
                    <div
                      style={{
                        color: 'red',
                        marginTop: '3px',
                        fontSize: '13px',
                      }}
                    >
                      {helperTextDetailActivity}
                    </div>
                  ) : null}
                </FormControl>
              </Grid>
            </Grid>
          )}

          {showClass && (
            <Grid container spacing={1} className="input__container">
              <Grid
                container
                style={{
                  paddingLeft: '50px',
                  paddingTop: '10px',
                  paddingBottom: '10px',
                }}
              >
                <Grid item xs={12} sm={12} md={12}>
                  <label className="responsiveLabel">Clase</label>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <FormControl fullWidth>
                    <Select
                      id="clase"
                      value={selectedClass}
                      onChange={(e) => {
                        handleClass(e.target.value)
                      }}
                      variant="outlined"
                    >
                      <MenuItem value={''}>Seleccione una opción</MenuItem>
                      <MenuItem value={1}>Clase I</MenuItem>
                      <MenuItem value={2}>Clase II</MenuItem>
                      <MenuItem value={3}>Clase III</MenuItem>
                      <MenuItem value={4}>Clase IV</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>
          )}

          {showQuestion && questions.length > 0 ? (
            questions.map((item, key) => {
              contador += 1

              return (
                <Grid
                  container
                  spacing={1}
                  className="input__container"
                  key={key}
                >
                  <Grid
                    container
                    style={{
                      paddingLeft: '50px',
                      paddingTop: '10px',
                      paddingBottom: '10px',
                    }}
                  >
                    <Grid item xs={12} sm={12} md={12}>
                      <label className="responsiveLabel">
                        15.{contador}. {item.QuestionName} {percentageTitle}
                      </label>
                    </Grid>

                    {resultEmpleados && (
                      <Grid item xs={12} sm={12} md={12}>
                        <FormControl fullWidth>
                          <TextField
                            id={`idNumeric-${item.IdActivityQuestion}`}
                            disabled
                            placeholder={setPlaceholderActivitySector(
                              item.IdActivityQuestion,
                            )}
                            name="questionNumeric"
                            style={{ width: '100%' }}
                            variant="outlined"
                            onChange={(e) => {
                              checkInputNumeric(
                                e.target.value,
                                `idNumeric-${item.IdActivityQuestion}`,
                                item.IdActivityQuestion,
                                item.QuestionTypeName,
                              )
                            }}
                            inputProps={{
                              maxLength: 13,
                              min: 0,
                              step: '2',
                              autoComplete: 'off',
                              pattern: item.AnswerPattern,
                            }}
                            value={preEligibilityForm.quantityEmployees}
                          />
                          {formik.errors.questionNumeric ? (
                            <div
                              style={{
                                color: 'red',
                                marginTop: '3px',
                                fontSize: '13px',
                              }}
                            >
                              {formik.errors.questionNumeric}
                            </div>
                          ) : null}
                          <div
                            id={`idNumericError-${item.IdActivityQuestion}`}
                            style={{
                              color: 'red',
                              marginTop: '3px',
                              fontSize: '13px',
                            }}
                          ></div>
                        </FormControl>
                      </Grid>
                    )}

                    {item.QuestionTypeName === 'Numeric' && !resultEmpleados && (
                      <Grid item xs={12} sm={12} md={12}>
                        <FormControl fullWidth>
                          {/* <TextField
                            id={`idNumeric-${item.IdActivityQuestion}`}
                            disabled={validateActivitySector(
                              item.IdActivityQuestion,
                            )}
                            placeholder={setPlaceholderActivitySector(
                              item.IdActivityQuestion,
                            )}

                            name="questionNumeric"
                            style={{ width: '100%' }}
                            variant="outlined"
                            onChange={(e) => {
                              checkInputNumeric(
                                e.target.value,
                                `idNumeric-${item.IdActivityQuestion}`,
                                item.IdActivityQuestion,
                                item.QuestionTypeName,
                              )
                            }}
                            inputProps={{
                              maxLength: 13,
                              min: 0,
                              step: '2',
                              autoComplete: 'off',
                              pattern: item.AnswerPattern,
                            }}
                          /> */}
                          <NumberFormat
                            id={`idNumeric-${item.IdActivityQuestion}`}
                            disabled={validateActivitySector(
                              item.IdActivityQuestion,
                            )}
                            name="questionNumeric"
                            style={{ width: '100%' }}
                            customInput={TextField}
                            thousandSeparator={true}
                            placeholder={setPlaceholderActivitySector(
                              item.IdActivityQuestion,
                            )}
                            onChange={(e) => {
                              checkInputNumeric(
                                e.target.value.replaceAll(',', ''),
                                `idNumeric-${item.IdActivityQuestion}`,
                                item.IdActivityQuestion,
                                item.QuestionTypeName,
                              )
                            }}
                            autoComplete="off"
                            allowNegative={false}
                            variant="outlined"
                            isNumericString={true}
                            inputProps={{
                              maxLength: item.Size + 1,
                              min: 0,
                              step: '2',
                              autoComplete: 'off',
                            }}
                            decimalScale={0}
                          />
                          {formik.errors.questionNumeric ? (
                            <div
                              style={{
                                color: 'red',
                                marginTop: '3px',
                                fontSize: '13px',
                              }}
                            >
                              {formik.errors.questionNumeric}
                            </div>
                          ) : null}
                          <div
                            id={`idNumericError-${item.IdActivityQuestion}`}
                            style={{
                              color: 'red',
                              marginTop: '3px',
                              fontSize: '13px',
                            }}
                          ></div>
                          <div
                            id={`validateAmount-${item.IdActivityQuestion}`}
                            style={{
                              color: 'red',
                              marginTop: '3px',
                              fontSize: '13px',
                            }}
                          ></div>
                        </FormControl>
                      </Grid>
                    )}

                    {item.QuestionTypeName === 'Decimal' && (
                      <Grid item xs={12} sm={12} md={12}>
                        <FormControl fullWidth>
                          {/* <TextField
                            id={`idDecimal-${item.IdActivityQuestion}`}
                            name="questionDecimal"
                            style={{ width: '100%' }}
                            variant="outlined"
                            disabled={validateActivitySector(
                              item.IdActivityQuestion,
                            )}
                            placeholder={setPlaceholderActivitySector(
                              item.IdActivityQuestion,
                            )}
                            onChange={(e) => {
                              checkInputDecimal(
                                e.target.value,
                                `idDecimal-${item.IdActivityQuestion}`,
                                item.IdActivityQuestion,
                                item.QuestionTypeName,
                              )
                            }}
                            inputProps={{
                              maxLength: 13,
                              min: 0,
                              autoComplete: 'off',
                              pattern: item.AnswerPattern,
                            }}
                          /> */}
                          <NumberFormat
                            id={`idDecimal-${item.IdActivityQuestion}`}
                            name="questionDecimal"
                            style={{ width: '100%' }}
                            customInput={TextField}
                            thousandSeparator={true}
                            disabled={validateActivitySector(
                              item.IdActivityQuestion,
                            )}
                            placeholder={setPlaceholderActivitySector(
                              item.IdActivityQuestion,
                            )}
                            onChange={(e) => {
                              checkInputDecimal(
                                e.target.value.replaceAll(',', ''),
                                `idDecimal-${item.IdActivityQuestion}`,
                                item.IdActivityQuestion,
                                item.QuestionTypeName,
                              )
                            }}
                            autoComplete="off"
                            allowNegative={false}
                            error={formik.errors.requiredAmountSourceCurrency}
                            variant="outlined"
                            isNumericString={true}
                            inputProps={{
                              maxLength: 18,
                              min: 0,
                              autoComplete: 'off',
                            }}
                            fixedDecimalScale
                            decimalScale={2}
                          />
                          {formik.errors.questionDecimal ? (
                            <div
                              style={{
                                color: 'red',
                                marginTop: '3px',
                                fontSize: '13px',
                              }}
                            >
                              {formik.errors.questionDecimal}
                            </div>
                          ) : null}
                          <div
                            id={`idDecimalError-${item.IdActivityQuestion}`}
                            style={{
                              color: 'red',
                              marginTop: '3px',
                              fontSize: '13px',
                            }}
                          ></div>
                          <div
                            id={`idDecimalErrorValidate-${item.IdActivityQuestion}`}
                            style={{
                              color: 'red',
                              marginTop: '3px',
                              fontSize: '13px',
                            }}
                          ></div>
                        </FormControl>
                      </Grid>
                    )}

                    {item.QuestionTypeName === 'String' && (
                      <Grid item xs={12} sm={12} md={12}>
                        <FormControl fullWidth>
                          <TextField
                            id={`idString-${item.IdActivityQuestion}`}
                            style={{ width: '100%' }}
                            variant="outlined"
                            inputProps={{
                              autoComplete: 'off',
                              pattern: item.AnswerPattern,
                              maxLength: item.AnswerMaxLenght,
                            }}
                            type="text"
                            onChange={(e) => {
                              /* checkInputString(
                                e.target.value,
                                `idString-${item.IdActivityQuestion}`,
                                item.IdActivityQuestion,
                                item.QuestionTypeName,
                              ) */
                              handleQuestions(
                                item.IdActivityQuestion,
                                e.target.value,
                                item.QuestionTypeName,
                              )
                            }}
                          />
                        </FormControl>
                        <div
                          id={`idStringError-${item.IdActivityQuestion}`}
                          style={{
                            color: 'red',
                            marginTop: '3px',
                            fontSize: '13px',
                          }}
                        ></div>
                      </Grid>
                    )}

                    {item.QuestionTypeName === 'Boolean' && (
                      <Grid item xs={12} sm={12} md={12}>
                        <FormControl style={{ width: '100%' }}>
                          <RadioGroup
                            id="affectsCulturalHeritage"
                            aria-labelledby="demo-radio-buttons-group-label"
                            name="radio-buttons-group"
                            onChange={(e) => {
                              handleQuestions(
                                item.IdActivityQuestion,
                                e.target.value === 'si' ? 'true' : 'false',
                                item.QuestionTypeName,
                              )
                            }}
                          >
                            <FormControlLabel
                              value="si"
                              control={<Radio />}
                              label="Si"
                            />
                            <FormControlLabel
                              value="no"
                              control={<Radio />}
                              label="No"
                            />
                          </RadioGroup>
                          {errorRadioAffectsCulturalHeritageDetail ? (
                            <div
                              style={{
                                color: 'red',
                                marginTop: '3px',
                                fontSize: '13px',
                              }}
                            >
                              {helperTextAffectsCulturalHeritageDetail}
                            </div>
                          ) : null}
                        </FormControl>
                      </Grid>
                    )}

                    {item.QuestionTypeName === 'ListValues' && (
                      <Grid item xs={12} sm={12} md={12}>
                        <FormControl style={{ width: '100%' }}>
                          <Select
                            id={`idSelect-${item.IdActivityQuestion}`}
                            onChange={(e) => {
                              if (userCountry === '1') {
                                setPreEligibilityForm({
                                  ...preEligibilityForm,
                                  answerActivityQuestion: [],
                                })
                                setQuetionsData([])
                              }
                              handleQuestions(
                                item.IdActivityQuestion,
                                e.target.value,
                                item.QuestionTypeName,
                              )
                              setSelectedActivitySector(e.target.value)
                            }}
                            inputProps={{
                              id: `idInputSelect-${item.IdActivityQuestion}`,
                            }}
                            variant="outlined"
                          >
                            <MenuItem value={''}>
                              Seleccione una opción
                            </MenuItem>
                            {item.ListOptionValues &&
                              item.ListOptionValues.split('|').map(
                                (item, key) => (
                                  <MenuItem key={key} value={item}>
                                    {item}
                                  </MenuItem>
                                ),
                              )}
                          </Select>
                        </FormControl>
                        <div
                          id={`idSelectError-${item.IdActivityQuestion}`}
                          style={{
                            color: 'red',
                            marginTop: '3px',
                            fontSize: '13px',
                          }}
                        ></div>
                      </Grid>
                    )}

                    {item.QuestionTypeName === 'Subcategory' && (
                      <Grid item xs={12} sm={12} md={12}>
                        <FormControl fullWidth>
                          <TextField
                            id={`idSubcategory-${item.IdActivityQuestion}`}
                            style={{ width: '100%' }}
                            variant="outlined"
                            type="text"
                            disabled={validateAll(
                              item.IdActivityQuestion,
                              item.QuestionName,
                            )}
                            placeholder={validatePlaceHolder(
                              item.IdActivityQuestion,
                              item.QuestionName,
                            )}
                            onChange={(e) => {
                              checkInputCategory(
                                e.target.value,
                                `idSubcategory-${item.IdActivityQuestion}`,
                                item.IdActivityQuestion,
                                item.QuestionTypeName,
                              )
                            }}
                            inputProps={{
                              maxLength: 5,
                              min: 0,
                              autoComplete: 'off',
                              pattern: item.AnswerPattern,
                            }}
                          />
                        </FormControl>
                      </Grid>
                    )}
                  </Grid>
                </Grid>
              )
            })
          ) : (
            <></>
          )}

          <Grid container spacing={1} className="input__container">
            <Grid item xs={12} sm={12} md={12}>
              <label className="responsiveLabel">
                16. ¿El proyecto afecta el patrimonio cultural?{' '}
                <span style={{ color: 'red' }}>*</span>
                <a
                  data-tip="Sitio arqueológico, monumento nacional, etc."
                  data-for="infoPatrimonio"
                  style={{ cursor: 'pointer' }}
                >
                  <ErrorOutlineIcon fontSize="small" />
                  <ReactTooltip
                    id="infoPatrimonio"
                    effect="solid"
                    multiline={true}
                    type="dark"
                    place="right"
                  />
                </a>
              </label>
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <FormControl style={{ width: '100%' }}>
                <RadioGroup
                  id="affectsCulturalHeritage"
                  aria-labelledby="demo-radio-buttons-group-label"
                  name="radio-buttons-group"
                  onChange={(e) => handleChangeAffectsCulturalHeritage(e)}
                >
                  <FormControlLabel value="si" control={<Radio />} label="Si" />
                  <FormControlLabel value="no" control={<Radio />} label="No" />
                </RadioGroup>
                {errorRadioAffectsCulturalHeritageDetail ? (
                  <div
                    style={{ color: 'red', marginTop: '3px', fontSize: '13px' }}
                  >
                    {helperTextAffectsCulturalHeritageDetail}
                  </div>
                ) : null}
              </FormControl>
            </Grid>
          </Grid>

          {showAffectsCulturalHeritageDetail && (
            <Grid container spacing={1} className="input__container">
              <Grid item xs={12} sm={12} md={12}>
                <label className="responsiveLabel">
                  16.1. Más detalles de cómo afecta el proyecto al patrimonio
                  cultural
                </label>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <FormControl fullWidth>
                  <TextField
                    id="detailActivity"
                    style={{ width: '100%' }}
                    variant="outlined"
                    inputProps={{ autoComplete: 'off', maxLength: 95 }}
                    value={formik.values.detailAffectsCulturalHeritage}
                    error={errorDetailAffectsCulturalHeritage}
                    onChange={(e) => {
                      formik.setFieldValue(
                        'detailAffectsCulturalHeritage',
                        e.target.value,
                      )
                      setHelperTextDetailAffectsCulturalHeritage('')
                      setErrorDetailAffectsCulturalHeritage(false)
                      setPreEligibilityForm({
                        ...preEligibilityForm,
                        detailAffectsCulturalHeritage: e.target.value,
                      })
                    }}
                  />
                  {errorDetailAffectsCulturalHeritage ? (
                    <div
                      style={{
                        color: 'red',
                        marginTop: '3px',
                        fontSize: '13px',
                      }}
                    >
                      {helperTextDetailAffectsCulturalHeritage}
                    </div>
                  ) : null}
                </FormControl>
              </Grid>
            </Grid>
          )}

          <Grid container spacing={1} className="input__container">
            <Grid item xs={12} sm={12} md={12}>
              <label className="responsiveLabel">
                17. ¿El proyecto está en un área protegida nacional?{' '}
                <span style={{ color: 'red' }}>*</span>
                <a
                  data-tip="No incluye áreas protegidas privadas."
                  data-for="infoArea"
                  style={{ cursor: 'pointer' }}
                >
                  <ErrorOutlineIcon fontSize="small" />
                  <ReactTooltip
                    id="infoArea"
                    effect="solid"
                    multiline={true}
                    type="dark"
                    place="right"
                  />
                </a>
              </label>
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <FormControl style={{ width: '100%' }}>
                <RadioGroup
                  id="isInProtectedArea"
                  aria-labelledby="demo-radio-buttons-group-label"
                  name="radio-buttons-group"
                  onChange={(e) => handleChangeIsInProtectedArea(e)}
                >
                  <FormControlLabel value="si" control={<Radio />} label="Si" />
                  <FormControlLabel value="no" control={<Radio />} label="No" />
                </RadioGroup>
                {errorRadioisInProtectedArea ? (
                  <div
                    style={{ color: 'red', marginTop: '3px', fontSize: '13px' }}
                  >
                    {helperTextIsInProtectedArea}
                  </div>
                ) : null}
              </FormControl>
            </Grid>
          </Grid>

          {showIsInProtectedArea && (
            <Grid container spacing={1} className="input__container">
              <Grid item xs={12} sm={12} md={12}>
                <label className="responsiveLabel">
                  17.1. Más detalles de la localización del área protegida
                </label>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <FormControl fullWidth>
                  <TextField
                    id="detailIsInProtectedArea"
                    name="protectedAreaLocation"
                    style={{ width: '100%' }}
                    variant="outlined"
                    inputProps={{
                      autoComplete: 'off',
                      maxLength: 150,
                      // pattern: '[\\sa-zA-ZñÑ0-9/#()-]{0,150}',
                      pattern: '[a-zA-ZñÑáéíóúÁÉÍÓÚ0-9/#()-\\s]{0,150}',
                    }}
                    value={formik.values.protectedAreaLocation}
                    error={errorDetailisInProtectedArea}
                    onChange={(e) => {
                      if (e.target.validity.valid) {
                        formik.setFieldValue(
                          'protectedAreaLocation',
                          e.target.value,
                        )
                        setHelperTextDetailIsInProtectedArea('')
                        setErrorDetailisInProtectedArea(false)
                        setPreEligibilityForm({
                          ...preEligibilityForm,
                          protectedAreaLocation: e.target.value,
                        })
                      }
                    }}
                  />
                  {errorDetailisInProtectedArea ? (
                    <div
                      style={{
                        color: 'red',
                        marginTop: '3px',
                        fontSize: '13px',
                      }}
                    >
                      {helperTextDetailIsInProtectedArea}
                    </div>
                  ) : null}
                </FormControl>
              </Grid>
            </Grid>
          )}

          <Grid container spacing={1} className="input__container">
            <Grid item xs={12} sm={12} md={12}>
              <label className="responsiveLabel">
                18. Amenaza climática por atender{' '}
                <span style={{ color: 'red' }}>*</span>
                <a
                  data-tip="Seleccione la amenaza climática a la que está<br/>o podría estar expuesta la actividad operativa."
                  data-for="infoClimate"
                  style={{ cursor: 'pointer' }}
                >
                  <ErrorOutlineIcon fontSize="small" />
                  <ReactTooltip
                    id="infoClimate"
                    effect="solid"
                    multiline={true}
                    type="dark"
                  />
                </a>
              </label>
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <FormControl fullWidth>
                <Select
                  id="idClimateThreat"
                  value={formik.values.idClimateThreat}
                  onChange={(e) => {
                    formik.setFieldValue('idClimateThreat', e.target.value)
                    if (e.target.value === 12) {
                      setShowClimateThreatDetail(true)
                      setPreEligibilityForm({
                        ...preEligibilityForm,
                        idClimateThreat: e.target.value,
                      })
                    }

                    if (e.target.value !== 12) {
                      setShowClimateThreatDetail(false)
                      setPreEligibilityForm({
                        ...preEligibilityForm,
                        detailClimateThreat: '',
                        idClimateThreat: e.target.value,
                      })
                      setErrorDetailClimateThreat(false)
                      setHelperTextDetailClimateThreat('')
                      formik.setValues({
                        ...formik.values,
                        idClimateThreat: e.target.value,
                        detailClimateThreat: '',
                      })
                    }
                  }}
                  variant="outlined"
                  error={formik.errors.idClimateThreat}
                >
                  <MenuItem value={''}>Seleccione una opción</MenuItem>
                  {climateThreat &&
                    climateThreat.map((item, key) => (
                      <MenuItem
                        key={key}
                        value={item.IdClimateThreat}
                        className="overFlowText"
                      >
                        {item.Description}
                      </MenuItem>
                    ))}
                </Select>
                {formik.errors.idClimateThreat ? (
                  <div
                    style={{ color: 'red', marginTop: '3px', fontSize: '13px' }}
                  >
                    {formik.errors.idClimateThreat}
                  </div>
                ) : null}
              </FormControl>
            </Grid>
          </Grid>

          {showClimateThreatDetail && (
            <Grid container spacing={1} className="input__container">
              <Grid item xs={12} sm={12} md={12}>
                <label className="responsiveLabel">
                  18.1. Detallar el peligro identificado
                </label>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <FormControl fullWidth>
                  <TextField
                    id="detailClimateThreat"
                    style={{ width: '100%' }}
                    variant="outlined"
                    inputProps={{ autoComplete: 'off', maxLength: 95 }}
                    error={errorDetailClimateThreat}
                    value={formik.values.detailClimateThreat}
                    onChange={(e) => {
                      formik.setFieldValue(
                        'detailClimateThreat',
                        e.target.value,
                      )
                      setPreEligibilityForm({
                        ...preEligibilityForm,
                        detailClimateThreat: e.target.value,
                      })
                      setHelperTextDetailClimateThreat('')
                      setErrorDetailClimateThreat(false)
                    }}
                  />
                  {errorDetailClimateThreat ? (
                    <div
                      style={{
                        color: 'red',
                        marginTop: '3px',
                        fontSize: '13px',
                      }}
                    >
                      {helperTextDetailClimateThreat}
                    </div>
                  ) : null}
                </FormControl>
              </Grid>
            </Grid>
          )}

          <Grid container spacing={1} className="input__container">
            <Grid item xs={12} sm={12} md={12}>
              <label className="responsiveLabel">
                19. Impactos negativos <span style={{ color: 'red' }}>*</span>
                <a
                  data-tip="Seleccione el/los impacto(s) negativo(s) que enfrenta la MIPYME por<br/> la amenaza climática a la que está o podría estar expuesto."
                  data-for="infoNegative"
                  style={{ cursor: 'pointer' }}
                >
                  <ErrorOutlineIcon fontSize="small" />
                  <ReactTooltip
                    id="infoNegative"
                    effect="solid"
                    multiline={true}
                    type="dark"
                  />
                </a>
              </label>
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      value="Productivos"
                      onChange={(e) => handleChangeNegativeImpact(e)}
                    />
                  }
                  label="Productivos"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      value="Económicos"
                      onChange={(e) => handleChangeNegativeImpact(e)}
                    />
                  }
                  label="Económicos"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      value="Ambientales (Biodiversidad, Físicos, Químicos, Biofísicos y otros)"
                      onChange={(e) => handleChangeNegativeImpact(e)}
                    />
                  }
                  label="Ambientales (Biodiversidad, Físicos, Químicos, Biofísicos y otros)"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      value="Sociales"
                      onChange={(e) => handleChangeNegativeImpact(e)}
                    />
                  }
                  label="Sociales"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      value="Otros"
                      onChange={(e) => handleChangeNegativeImpact(e)}
                    />
                  }
                  label="Otros"
                />
              </FormGroup>
              {errorCheckNegativeImpact ? (
                <div
                  style={{ color: 'red', marginTop: '3px', fontSize: '13px' }}
                >
                  {helperTextNegativeImpact}
                </div>
              ) : null}
            </Grid>
          </Grid>

          <Grid container spacing={1} className="input__container">
            <Grid item xs={12} sm={12} md={12}>
              <label className="responsiveLabel">
                20. Medida de adaptación a implementar{' '}
                <span style={{ color: 'red' }}>*</span>
                <a
                  data-tip="Seleccione la opción que considere más importante."
                  data-for="infoMedida"
                  style={{ cursor: 'pointer' }}
                >
                  <ErrorOutlineIcon fontSize="small" />
                  <ReactTooltip
                    id="infoMedida"
                    effect="solid"
                    multiline={true}
                    type="dark"
                    place="right"
                  />
                </a>
              </label>
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <FormControl fullWidth>
                <Select
                  id="idAdaptationAction"
                  value={formik.values.idAdaptationAction}
                  onChange={(e) => {
                    formik.setFieldValue('idAdaptationAction', e.target.value)
                    if (e.target.value === 24) {
                      setShowAdaptationActionsDetail(true)
                      setPreEligibilityForm({
                        ...preEligibilityForm,
                        idAdaptationAction: e.target.value,
                      })
                    }
                    if (e.target.value !== 24) {
                      setShowAdaptationActionsDetail(false)
                      setPreEligibilityForm({
                        ...preEligibilityForm,
                        detailAdaptationAction: '',
                        idAdaptationAction: e.target.value,
                      })
                      setErrorDetailAdaptationActions(false)
                      setHelperTextDetailAdaptationActions('')
                      formik.setValues({
                        ...formik.values,
                        idAdaptationAction: e.target.value,
                        detailAdaptationAction: '',
                      })
                    }
                  }}
                  variant="outlined"
                  error={formik.errors.idAdaptationAction}
                >
                  <MenuItem value={''}>Seleccione una opción</MenuItem>
                  {adaptationActions.map((item, key) => (
                    <MenuItem
                      key={key}
                      value={item.IdAdaptationAction}
                      className="overFlowText"
                    >
                      {item.Description}
                    </MenuItem>
                  ))}
                </Select>
                {formik.errors.idAdaptationAction ? (
                  <div
                    style={{ color: 'red', marginTop: '3px', fontSize: '13px' }}
                  >
                    {formik.errors.idAdaptationAction}
                  </div>
                ) : null}
              </FormControl>
            </Grid>
          </Grid>

          {showAdaptationActionsDetail && (
            <Grid container spacing={1} className="input__container">
              <Grid item xs={12} sm={12} md={12}>
                <label className="responsiveLabel">
                  20.1. Detallar la medida de adaptación
                </label>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <FormControl fullWidth>
                  <TextField
                    id="detailAdaptationAction"
                    style={{ width: '100%' }}
                    variant="outlined"
                    inputProps={{ autoComplete: 'off', maxLength: 95 }}
                    error={errorDetailAdaptationActions}
                    value={formik.values.detailAdaptationAction}
                    onChange={(e) => {
                      formik.setFieldValue(
                        'detailAdaptationAction',
                        e.target.value,
                      )
                      setPreEligibilityForm({
                        ...preEligibilityForm,
                        detailAdaptationAction: e.target.value,
                      })
                      setHelperTextDetailAdaptationActions('')
                      setErrorDetailAdaptationActions(false)
                    }}
                  />
                  {errorDetailAdaptationActions ? (
                    <div
                      style={{
                        color: 'red',
                        marginTop: '3px',
                        fontSize: '13px',
                      }}
                    >
                      {helperTextDetailAdaptationActions}
                    </div>
                  ) : null}
                </FormControl>
              </Grid>
            </Grid>
          )}

          <Grid container spacing={1} className="input__container">
            <Grid item xs={12} sm={12} md={12}>
              <label className="responsiveLabel">
                21. Consideraciones especiales. ¿Su actividad se relaciona con
                alguna de las siguientes?{' '}
                <span style={{ color: 'red' }}>*</span>
                <a
                  data-tip="Seleccione el Giro del Negocio de la MIPYME,<br/> si este no está desplegado en el listado,<br/> colocar Ninguno de los anteriores."
                  data-for="infoConsideraciones"
                  style={{ cursor: 'pointer' }}
                >
                  <ErrorOutlineIcon fontSize="small" />
                  <ReactTooltip
                    id="infoConsideraciones"
                    effect="solid"
                    multiline={true}
                    type="dark"
                    place="right"
                  />
                </a>
              </label>
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <FormControl fullWidth>
                <Select
                  id="lineOfBusiness"
                  value={formik.values.idBusinessLine}
                  onChange={(e) => {
                    formik.setFieldValue('idBusinessLine', e.target.value)
                    setPreEligibilityForm({
                      ...preEligibilityForm,
                      idBusinessLine: e.target.value,
                    })
                  }}
                  variant="outlined"
                  error={formik.errors.idBusinessLine}
                >
                  <MenuItem value={''}>Seleccione una opción</MenuItem>
                  {lineOfBusiness &&
                    lineOfBusiness.map((item, key) => (
                      <MenuItem
                        key={key}
                        value={item.IdBusinessLine}
                        className="overFlowText"
                      >
                        {item.Description}
                      </MenuItem>
                    ))}
                </Select>
                {formik.errors.idBusinessLine ? (
                  <div
                    style={{ color: 'red', marginTop: '3px', fontSize: '13px' }}
                  >
                    {formik.errors.idBusinessLine}
                  </div>
                ) : null}
              </FormControl>
            </Grid>
          </Grid>

          <Grid container spacing={1} style={{ marginTop: '24px' }}>
            <Grid item xs={12} sm={12} md={12}>
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      name="status"
                      onChange={handleChangeDeclaration}
                    />
                  }
                  label="Declaro que he completado el formulario con información veraz"
                />
              </FormGroup>
              {errorCompilanceStatement ? (
                <div
                  style={{ color: 'red', marginTop: '3px', fontSize: '13px' }}
                >
                  {helperTextCompilanceStatement}
                </div>
              ) : null}
            </Grid>
          </Grid>

          <Grid container spacing={1} className="button__container">
            <Grid
              item
              xs={12}
              sm={6}
              md={6}
              style={{ textAlign: 'left' }}
              className="continerButtonNav"
            >
              <Button
                onClick={() => previous()}
                variant="contained"
                className="button__wizard button__previous"
                disabled={loading}
              >
                Anterior
              </Button>
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
              md={6}
              style={{ textAlign: 'right' }}
              className="continerButtonNav"
            >
              <Button
                onClick={() => validateFormStatus()}
                type="submit"
                variant="contained"
                className="button__wizard button__next"
                disabled={loading}
              >
                {loading ? (
                  <CircularProgress size={23} color="white" />
                ) : (
                  'Registrar'
                )}
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </form>
    </>
  )
}

export default EvaluationData
